import styled from "styled-components";

export const AccountPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 0px 48px;
`
export const AccountContent = styled.div`
    align-items: start;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .horizontal-divider {
        width: 100%;
        height: 1px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    h1 {
        color: #FFFFFF;
        font-size: 48px;
        opacity: 0.2;
    }
`

export const MainGradientBGContainer = styled.div`
    height: 100vh;
    position: fixed;
    width: 100vw;
    top: 0;
    z-index: -500;
`
export const DualColumnContainer = styled.div`
    display: flex;
    gap: 24px;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
`